import { render, staticRenderFns } from "./AlbumSettingsMenuDropdown.vue?vue&type=template&id=33965544&"
import script from "./AlbumSettingsMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./AlbumSettingsMenuDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports